$.ready(function() {
	let oldGameLast = null;

	game.on('spin_ready', function(e) {
		if (game.feature.active === 'freespin') {
			if (game.last.scatters.counts[12] === 2) {
				game.last.delayWin = true;
			}
		}
	});

	game.on('spin_done', function(e) {
		if (game.last.delayWin) {
			game.pays.show();
			setTimeout(function() {
				game.panel.hide(true);
				game.feature.messages.removeClass('hide');
				startPickBonus();
			}, 2000);
		}
	});

	function startPickBonus() {
		var pick_bonus = game.features.freespin.pick_bonus = $.div().addClass('bonus-pick').appendTo(game.features.freespin);
		pick_bonus.panning = $.div().addClass('panning').appendTo(pick_bonus);
		pick_bonus.panning.panSpot = [];

		game.sounds.fade([ 'freespin', 'background' ], 1, 0, 0.5);
		game.sounds.play([ 'pickbonus', 'background' ], { loop: true, gain: 1 });

		pick_bonus.clickDisabled = false;
		pick_bonus.numSpots = 13;

		for (var i = 0; i < pick_bonus.numSpots; i++) {
			pick_bonus.panning.panSpot.push($.div().addClass('panSpot _' + i));
			pick_bonus.panning.panSpot[i].appendTo(pick_bonus.panning);
			pick_bonus.panning.panSpot[i].chosen = false;
			$.div().appendTo(pick_bonus.panning.panSpot[i]);
			pick_bonus.panning.panSpot[i].attr('class', 'panSpot _' + i);
		}

		pick_bonus.panning.on('click', 'panSpot', function() {
			var index = this.index();

			if (pick_bonus.clickDisabled || pick_bonus.panning.panSpot[index].chosen) {
				return;
			}

			pick_bonus.clickDisabled = true;
			pick_bonus.panning.panSpot[index].chosen = true;
			panPicked(index, pick_bonus);
		});
	};

	function panPicked (index, pick_bonus) {
		game.sounds.play([ 'pickbonus', 'pick' ]);

		pick_bonus.panning.panSpot[index].addClass('picked');
		setTimeout(function() {
			pick_bonus.panning.panSpot[index].removeClass('picked');
			pick_bonus.panning.panSpot[index].addClass('reveal');
			pick_bonus.panning.panSpot[index].overall = $.div().addClass('overall').apply('meter', { value: 0 }).appendTo(pick_bonus.panning.panSpot[index]);
			game.panel.registerCash(pick_bonus.panning.panSpot[index].overall);
			let denom_multiplier = game.panel.denom.get() || 1;
			pick_bonus.panning.panSpot[index].overall.set(game.last.award * denom_multiplier);
			resetCashToggle();
		}, 2200);

		setTimeout(function() { finishPickBonus(pick_bonus, index); }, 6000);
	};

	 function finishPickBonus (pick_bonus, index) {
		oldGameLast = game.last;
		game.controller.socket.emit('feature', { name: 'freespin', action: 'choose', index: index, award: game.last.award });
		pick_bonus.clickDisabled = true;
		pick_bonus.outro = $.div().addClass('outro').appendTo(pick_bonus);
		pick_bonus.outro.overall = $.div().addClass('overall').apply('meter', { value: 0 }).appendTo(pick_bonus.outro);
		game.panel.registerCash(pick_bonus.outro.overall);
		resetCashToggle();	
		
		let denom_multiplier = game.panel.denom.get() || 1;
			
		pick_bonus.outro.overall.set(game.last.award * denom_multiplier);// * game.panel.coins.values[game.panel.coins.value]);
		
		console.log(denom_multiplier, game.last.award);
		
		pick_bonus.panning.panSpot[index].overall.remove();

		setTimeout(function() {
			pick_bonus.addClass('hide');
			game.features.freespin.removeClass('bonus-pick');
			game.feature.messages.addClass('hide');
			setTimeout(function() {
				game.sounds.fade([ 'pickbonus', 'background' ], 1, 0, 0.5);
				game.sounds.play([ 'freespin', 'background' ], { loop: true });

				game.panel.show(true);
				game.last.delayWin = false;
				setTimeout(function() { game.panel.setWin(game.last.win); }, 1000);
				setTimeout(function() { pick_bonus.remove(); }, 5000);
			}, 2000);
		}, 4000);
	};

	function pickRecall (index, award) {
		var pick_bonus = game.features.freespin.pick_bonus = $.div().addClass('bonus-pick').appendTo(game.features.freespin);
		pick_bonus.panning = $.div().addClass('panning').appendTo(pick_bonus);
		pick_bonus.panning.panSpot = [];
		pick_bonus.numSpots = 13;

		for (var i = 0; i < pick_bonus.numSpots; i++) {
			pick_bonus.panning.panSpot.push($.div().addClass('panSpot _' + i));
			pick_bonus.panning.panSpot[i].appendTo(pick_bonus.panning);
			pick_bonus.panning.panSpot[i].chosen = false;
			$.div().appendTo(pick_bonus.panning.panSpot[i]);
			pick_bonus.panning.panSpot[i].attr('class', 'panSpot _' + i);
		}

		pick_bonus.panning.panSpot[index].addClass('picked');

		setTimeout(function() {
			pick_bonus.panning.panSpot[index].removeClass('picked');
			pick_bonus.panning.panSpot[index].addClass('reveal');
			pick_bonus.panning.panSpot[index].overall = $.div().addClass('overall').appendTo(pick_bonus.panning.panSpot[index]);
			pick_bonus.panning.panSpot[index].overall.html(award);
		}, 2200);

		setTimeout(function() { pick_bonus.remove(); }, 5000);
	};
	
	// Meters are created in credits by default, this updates the meter to the appropriate value (cash or credit)
	// It is used twice to reset it to the previous value
	function resetCashToggle() {
		game.panel.toggleCash();
		game.panel.toggleCash();
	}

	game.features.freespin.methods.choose = function(response) {
		if (game.inRecall) {
			pickRecall(response.index, response.award);
			return;
		}

		game.last = oldGameLast;
	};
});



/** WEBPACK FOOTER **
 ** ./public-src/free_pick.js
 **/